import React, { useState, useContext } from "react";
import { NoScenario, ScenariosList } from "./";
import { ScenarioSection } from "../../context/ScenarioContext";
import { useTranslation } from "react-i18next";
import { FiPlus, FiZap } from "react-icons/fi";

const ScenarioFirstPage = () => {
  const [showScenarios, setShowScenarios] = useState(false);
  const { ShowHideFunction } = useContext(ScenarioSection);
  const { t } = useTranslation();
  
  return (
    <div className="scenario-first-page">
      {/* Add Scenario Card */}
      <div className="scenario-add-card">
        <div className="scenario-add-icon">
          <FiZap size={24} />
        </div>
        <div className="scenario-add-content">
          <h3 className="scenario-add-title">{t("اضافه کردن سناریو")}</h3>
          <p className="scenario-add-description">
            {t("شما میتوانید سناریو دلخواه خود را اضافه کنید")}
          </p>
        </div>
        <button
          className="scenario-add-btn"
          onClick={() => ShowHideFunction("addPage")}
        >
          <FiPlus size={22} />
        </button>
      </div>

      {/* Scenarios List or Empty State */}
      {!showScenarios ? <NoScenario /> : <ScenariosList />}
    </div>
  );
};

export { ScenarioFirstPage };